export default __webpack_public_path__ + "static/media/cloth_12.b7a51b0a.jpg";